const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const VirtualMachine = require('../../virtual-machine');
// const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 小夜灯
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

const BLE_CONFIG = {
    prefix: 'LM',
    SERVICE_UUID: 0x01FF,
    LIGHT_SWITCH_UUID: 0x0200,
    BRIGHTNESS_UUID: 0x0201,
    FLASH_MODE_UUID: 0x0202,
    LIGHT_STENGTH_UUID: 0x0210,
    BODY_UUID: 0x0230,
}
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YMDLGT extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYMDLGTDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'ymDLGT';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        
        this._peripheral = new YMDLGT(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'ymDLGT',
            name: formatMessage({
                id: 'YMDLGT.categoryName',
                default: 'YM NLGT',
                description: 'Label for the YM NLGT extension category'
            }),
            color1: "#4CAF50",
            color2: "#47A94A",
            color3: "#429E44",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMDLGT.ble.connect',
                        default: 'connect to YM-NLGT-[DEVICE_NAME]',
                        description: 'Connect to YM-NLGT'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMDLGT.ble.disconnect',
                        default: 'disconnect from YM-NLGT',
                        description: 'Disconnect from YM-NLGT'
                    })
                },
                {
                    opcode: 'setLightSwitch',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMDLGT.setLightSwitch',
                        default: 'turn light [SWITCH]',
                        description: 'Turn the light on or off'
                    }),
                    arguments: {
                        SWITCH: {
                            type: ArgumentType.NUMBER,
                            menu: 'lightSwitch'
                        }
                    }
                },
                {
                    opcode: 'setBrightness',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMDLGT.setBrightness',
                        default: 'set brightness [BRIGHTNESS]',
                        description: 'Set the brightness of the light'
                    }),
                    arguments: {
                        BRIGHTNESS: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50,
                            minValue: 0,
                            maxValue: 100
                        }
                    }
                },
                {
                    opcode: 'setFlashMode',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMDLGT.setFlashMode',
                        default: 'turn flash mode [MODE]',
                        description: 'Turn the flash mode on or off'
                    }),
                    arguments: {
                        MODE: {
                            type: ArgumentType.NUMBER,
                            menu: 'flashMode'
                        }
                    }
                },
                {
                    opcode: 'getBrightness',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YMDLGT.getBrightness',
                        default: 'get brightness',
                        description: 'Get the brightness of the light'
                    })
                },
                {
                    opcode: 'getStatus',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'YMDLGT.getStatus',
                        default: 'detect current status',
                        description: 'Detect current status'
                    }),
                },
            ],
            menus: {
                lightSwitch: {
                   
                    items: [
                        {
                            text: formatMessage({
                                id: 'YMDLGT.setLightSwitch.1',
                                default: 'On',
                                description: 'Light switch on'
                            }), value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'YMDLGT.setLightSwitch.0',
                                default: 'Off',
                                description: 'Light switch off'
                            }), value: '0'
                        }
                    ]
                },
                flashMode: {
                   
                    items: [
                        {
                            text: formatMessage({
                                id: 'YMDLGT.setFlashMode.1',
                                default: 'On',
                                description: 'Flash light switch on'
                            }), value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'YMDLGT.setFlashMode.0',
                                default: 'Off',
                                description: 'Flash light switch off'
                            }), value: '0'
                        }
                    ]
                }
            }
        }];
    }

    async connect(args) {
        const deviceName = 'YM-NLGT-' + (args.DEVICE_NAME?.trim() || "");
        console.log(`Connecting to YM-NLGT device: ${deviceName}`);
        // Check if the device is already connected
        if (this.bleUtils.device && this.bleUtils.isConnected(this.bleUtils.device)) {
            console.log('Device is already connected');
            return;
        }
        // Attempt to connect to the device
        // Use the bleUtils to connect to the device
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);
        } catch (error) {
                // 区分不同类型的错误
            if (error.message === '用户取消了连接请求') {
                console.log('用户取消了连接');
            } else {
                console.error(`Failed to connect to ${deviceName}:`, error);
            }
        }
    }

    async disConnect() {
        console.log('Disconnecting from YM-NLGT device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    async setLightSwitch(args) {
        const state = args.SWITCH;
        console.log(`Turning light ${state === '1' ? 'on' : 'off'}`);
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.LIGHT_SWITCH_UUID);
                const stateValue = parseInt(state, 10);
                if (isNaN(stateValue)) {
                    console.error('Invalid state value:', state);
                    return;
                }
                const stateArray = new Uint8Array(1);
                stateArray[0] = stateValue;
                await this.bleUtils.writeCharacteristic(characteristic, stateArray);
            } catch (error) {
                console.error('Failed to set light switch:', error);
            }
        }
    }

    async setBrightness(args) {
        const brightness = args.BRIGHTNESS;
        console.log(`Setting brightness to ${brightness}`);
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.BRIGHTNESS_UUID);
                const brightnessValue = parseInt(brightness, 10);
                if (isNaN(brightnessValue)) {
                    console.error('Invalid brightness value:', brightness);
                    return;
                }
                const brightnessArray = new Uint8Array(1);
                brightnessArray[0] = brightnessValue;
                await this.bleUtils.writeCharacteristic(characteristic, brightnessArray);
            } catch (error) {
                console.error('Failed to set brightness:', error);
            }
        }
    }

    async setFlashMode(args) {
        const mode = args.MODE;
        console.log(`Turning flash mode ${mode === '1' ? 'on' : 'off'}`);
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.FLASH_MODE_UUID);
                const modeValue = parseInt(mode, 10);
                if (isNaN(modeValue)) {
                    console.error('Invalid mode value:', mode);
                    return;
                }
                const modeArray = new Uint8Array(1);
                modeArray[0] = modeValue;
                await this.bleUtils.writeCharacteristic(characteristic, modeArray);
            } catch (error) {
                console.error('Failed to set flash mode:', error);
            }
        }
    }

    async getBrightness() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.LIGHT_STENGTH_UUID);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                if (dataView?.buffer instanceof ArrayBuffer) {
                    //解析数据
                    let buffer = Array.from(new Uint8Array(dataView.buffer));
                    const hexStr = buffer.map(_ => {
                        return this.bleUtils.int2Hex(_);
                    }).reverse().join("");
                    const brightness = parseInt(hexStr, 16);
                    console.log(`Brightness: ${brightness}`);
                    return brightness;
                }
            } catch (error) {
                console.error('Failed to set brightness:', error);
            }
        }
    }

    async getStatus() {
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.BODY_UUID);
                const dataView = await this.bleUtils.readCharacteristic(characteristic);
                const status = dataView.getUint8(0);
                console.log('Status:', status);
                return status;
            } catch (error) {
                console.error('Failed to set light mode:', error);
            }
        }
    }
}

module.exports = ScratchYMDLGTDevice;